export default "__VITE_ASSET__e002a164__"